import {connect} from 'react-redux';
import ChangeEmailFinish from "./ChangeEmailFinish";
import { Utils } from '../../../utils/utils';
import {getSubmitFormError, getSubmitFormSuccessStatus} from "../../../reducers/common/submitForm";
import {getTranslation} from "../../../reducers/common/localization";
import {onSubmitChangeEmail} from "../../../reducers/account/restoreAccount";

const mapStateToProps = (state, {location}) => {
    let searchParams = Utils.getParamsFromLocationSearch(location.search);
    return {
        token: searchParams.token,
        success: getSubmitFormSuccessStatus(state),
        error: getSubmitFormError(state),
        translation: getTranslation(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onSubmitEmailChange: (token) => {
            dispatch(onSubmitChangeEmail(token));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangeEmailFinish);



// WEBPACK FOOTER //
// ./src/components/accountManagement/changeEmailFinish/ChangeEmailFinish.container.js